import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './AddressList.module.css';
import dateFunctions from '../../../utils/dateFunctions.js';

const ImageModal = ({ images, currentIndex, onClose, onPrev, onNext, countryCode, hidePostingDate }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') {
                onPrev();
            } else if (event.key === 'ArrowRight') {
                onNext();
            } else if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onPrev, onNext, onClose]);

    if (currentIndex === null || currentIndex < 0 || currentIndex >= images.length) {
        return null;
    }
    return createPortal(
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onClose}>x</button>
                <div className={styles.modalBody}>
                    <div className={styles.imageDetails}>
                        <p className={styles.detailText}><strong>Panel ID:</strong> {images[currentIndex]?.panelId}</p>
                        <p className={styles.detailText}><strong>Type:</strong> {images[currentIndex]?.environment}</p>
                        <p className={styles.detailText}><strong>Design:</strong> {images[currentIndex]?.design}</p>
                        <p className={styles.detailText}><strong>City:</strong> {images[currentIndex]?.city}</p>
                        <p className={styles.detailText}><strong>Address:</strong> {images[currentIndex]?.address}</p>
                        {!hidePostingDate && (
                            <p className={styles.detailText}><strong>Posting date:</strong> {dateFunctions.getCountrySpecificDateTimeFormatFromDate(countryCode, moment(images[currentIndex]?.timeStamp))}</p>
                        )}
                        <p className={styles.detailText}><strong>Status:</strong> {images[currentIndex]?.status}</p>
                    </div>
                    <div className={styles.imageContainer}>
                        <button className={styles.prevButton} onClick={onPrev}>&lt;</button>
                        <img src={images[currentIndex]?.imageUrl} alt="Enlarged view" className={styles.modalImage} />
                        <button className={styles.nextButton} onClick={onNext}>&gt;</button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ImageModal;
